import { IServer, IServiceInstance } from '@module/license/models';
import { handleErrors, SITE_API_URI } from '@service/constants';
import SiteApiClient from '@service/siteApiClient';

const client = new SiteApiClient(SITE_API_URI);

export function requestServicePost(serviceInstance: IServiceInstance, accessToken: string) {
    serviceInstance.id = 0;
    return new Promise(
        (resolve, reject) => {
            const req = client.addService(serviceInstance, accessToken).then(r => r.json()).then(data => {
                resolve(toServiceInstanceResponse(data));
            }).catch((err: any) => {
                reject(err);
            });
        }
    );
}

export function requestServicePut(serviceInstance: IServiceInstance, accessToken: string) {
    return new Promise(
        (resolve, reject) => {
            const req = client.updateService(serviceInstance, accessToken).then(data => {
                resolve(serviceInstance);
            }).catch((err: any) => {
                reject(err);
            });
        }
    );
}

export function requestServiceDelete(serviceInstance: IServiceInstance, accessToken: string) {
    return new Promise(
        (resolve, reject) => {
            const req = client.deleteService(serviceInstance, accessToken).then(data => {
                resolve(serviceInstance);
            });
        }
    );
}

function toServiceInstanceResponse(data: any) {
    const serviceInstanceResponse: IServiceInstance = {
        id: data.id,
        siteId: data.siteId,
        serverId: data.serverId,
        serviceList: [],
        selectedServiceType: data.selectedService,
        assetType: data.selectedService.assetType.assetTypeName,
        allocatedAssets: { value: data.allocatedAssets, valid: true },
        isBeingEdited: false,
        discriminator: ''
    };
    return serviceInstanceResponse;
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/services/serviceDataService.ts